<div class="status__text" [style]="statusStyle()">
  {{ statusName() }}
</div>
